<app-multimedia-grid-layout [templateColumns]="templateColumns()">
  @for (file of images(); track file.id; let index = $index) {
    @if (fetchMultimediaDetails(file.id) | async; as multimedia) {
      <app-multimedia-grid-layout-item>
        <app-multimedia-tile
          [info]="false"
          [type]="multimedia.type"
          [alt]="multimedia.alt"
          [filename]="multimedia.filename"
          [size]="multimedia.size"
          [previewUrl]="multimedia.thumbnailPreviewUrl"
          [downloadUrl]="multimedia.downloadUrl"
          [extension]="multimedia.extension"
          (previewClickEvent)="handlePreviewClick(index)"
          [mode]="mode(multimedia)" />
      </app-multimedia-grid-layout-item>
    } @else {
      <app-multimedia-grid-layout-item>
        <app-multimedia-tile mode="loading" />
      </app-multimedia-grid-layout-item>
    }
  }

  @for (file of documents(); track file.id) {
    @if (fetchMultimediaDetails(file.id) | async; as multimedia) {
      <app-multimedia-grid-layout-item>
        <app-multimedia-tile
          [info]="false"
          [type]="multimedia.type"
          [alt]="multimedia.alt"
          [filename]="multimedia.filename"
          [size]="multimedia.size"
          [previewUrl]="multimedia.thumbnailPreviewUrl"
          [downloadUrl]="multimedia.downloadUrl"
          [extension]="multimedia.extension"
          [mode]="mode(multimedia)" />
      </app-multimedia-grid-layout-item>
    } @else {
      <app-multimedia-grid-layout-item>
        <app-multimedia-tile mode="loading" />
      </app-multimedia-grid-layout-item>
    }
  }

  @for (file of others(); track file.id) {
    @if (fetchMultimediaDetails(file.id) | async; as multimedia) {
      <app-multimedia-grid-layout-item>
        <app-multimedia-tile
          [info]="false"
          [type]="multimedia.type"
          [alt]="multimedia.alt"
          [filename]="multimedia.filename"
          [size]="multimedia.size"
          [previewUrl]="multimedia.thumbnailPreviewUrl"
          [downloadUrl]="multimedia.downloadUrl"
          [extension]="multimedia.extension"
          [mode]="mode(multimedia)" />
      </app-multimedia-grid-layout-item>
    } @else {
      <app-multimedia-grid-layout-item>
        <app-multimedia-tile mode="loading" />
      </app-multimedia-grid-layout-item>
    }
  }
</app-multimedia-grid-layout>
